export const IconAvatar = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.54992 11.4416C10.8432 11.4416 11.8916 10.3932 11.8916 9.09997C11.8916 7.8067 10.8432 6.7583 9.54992 6.7583C8.25665 6.7583 7.20825 7.8067 7.20825 9.09997C7.20825 10.3932 8.25665 11.4416 9.54992 11.4416Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.875 16.8331C13.875 14.8915 11.9416 13.3081 9.54997 13.3081C7.15831 13.3081 5.22498 14.8831 5.22498 16.8331"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 10.4167C17.5 14.7917 13.9583 18.3333 9.58329 18.3333C5.20829 18.3333 1.66663 14.7917 1.66663 10.4167C1.66663 6.04167 5.20829 2.5 9.58329 2.5C10.675 2.5 11.7166 2.71666 12.6666 3.11666C12.5583 3.44999 12.5 3.8 12.5 4.16667C12.5 4.79167 12.675 5.38333 12.9833 5.88333C13.15 6.16666 13.3666 6.42498 13.6166 6.64164C14.2 7.17498 14.975 7.5 15.8333 7.5C16.2 7.5 16.55 7.44165 16.875 7.32498C17.275 8.27498 17.5 9.325 17.5 10.4167Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1667 4.16683C19.1667 4.4335 19.1333 4.69182 19.0667 4.94182C18.9917 5.27516 18.8583 5.60016 18.6833 5.88349C18.2833 6.55849 17.6417 7.08348 16.875 7.32514C16.55 7.44181 16.2 7.50016 15.8333 7.50016C14.975 7.50016 14.2 7.17514 13.6167 6.6418C13.3667 6.42514 13.15 6.16683 12.9833 5.88349C12.675 5.38349 12.5 4.79183 12.5 4.16683C12.5 3.80016 12.5583 3.45015 12.6667 3.11682C12.825 2.63349 13.0917 2.20018 13.4417 1.84185C14.05 1.21685 14.9 0.833496 15.8333 0.833496C16.8167 0.833496 17.7083 1.25851 18.3083 1.94184C18.8417 2.53351 19.1667 3.31683 19.1667 4.16683Z"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.075 4.15039H14.5917"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8334 2.93359V5.42525"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
